import { render, staticRenderFns } from "./dialogFormPreview.vue?vue&type=template&id=06d19c05&scoped=true"
import script from "./dialogFormPreview.vue?vue&type=script&lang=js"
export * from "./dialogFormPreview.vue?vue&type=script&lang=js"
import style0 from "./dialogFormPreview.vue?vue&type=style&index=0&id=06d19c05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d19c05",
  null
  
)

export default component.exports